import { useGlobalUIStore } from "@/betby/store/globalUIStore";
import { sendTokenExpiredConfirmMessage } from "@/betby/models/host/unityMessageService";

export interface NetworkRetryModalCallbacks {
  onConfirm?: () => void;
  onClose?: () => void;
}

export interface GlobalUiRuntime {
  showTokenExpiredModal?: (message?: string, title?: string) => void;
  showNetworkRetryModal?: (callbacks?: NetworkRetryModalCallbacks) => void;
  confirmTokenExpired?: () => void;
}

let activeGlobalUiRuntime: GlobalUiRuntime | null = null;

export function registerGlobalUiRuntime(runtime: GlobalUiRuntime | null): void {
  activeGlobalUiRuntime = runtime;
}

export function getGlobalUiRuntime(): GlobalUiRuntime | null {
  return activeGlobalUiRuntime;
}

export function createDefaultGlobalUiRuntime(): GlobalUiRuntime {
  return {
    showTokenExpiredModal: (message, title) => {
      useGlobalUIStore.getState().showTokenExpiredModal(message, title);
    },
    showNetworkRetryModal: (callbacks) => {
      useGlobalUIStore.getState().showNetworkRetryModal(callbacks);
    },
    confirmTokenExpired: () => {
      sendTokenExpiredConfirmMessage();
    },
  };
}
